// GENERATED CODE - DO NOT MODIFY BY HAND

import * as m from '@april9au/stack9-sdk';
import { z } from 'zod';

export const Topic = z.object({
  name: m.ZTextField,
  slug: m.ZTextField,
  topic_thumbnail: m.ZFileField.optional().nullable(),
  sub_heading: m.ZTextField,
  topic_summary: m.ZRichTextEditor.optional().nullable(),
  featured_resources: m.ZCustomUIComponent.optional().nullable(),
});
export type Topic = z.infer<typeof Topic>;

export const DBTopic = m.ZEntityInterface.merge(Topic);
export type DBTopic = z.infer<typeof DBTopic>;
